import { render, staticRenderFns } from "./TracingSuborderBox.vue?vue&type=template&id=f2e42266&scoped=true"
import script from "./TracingSuborderBox.vue?vue&type=script&lang=js"
export * from "./TracingSuborderBox.vue?vue&type=script&lang=js"
import style0 from "./TracingSuborderBox.vue?vue&type=style&index=0&id=f2e42266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e42266",
  null
  
)

export default component.exports